import '../base/bootstrap';
window.$ = require('jquery');
